import { render, staticRenderFns } from "./CartFreeGift.vue?vue&type=template&id=5752376e&"
import script from "./CartFreeGift.vue?vue&type=script&lang=ts&"
export * from "./CartFreeGift.vue?vue&type=script&lang=ts&"
import style0 from "./CartFreeGift.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports